const certifications = [
  "BTS Maintenance des systèmes : 1 candidat présenté / 1 certification obtenue ✅",
  "BTS MCO : 1 candidat présenté / 1 certification obtenue ✅",
  "Bac pro Maintenance des matériels : 1 candidat présenté / 1 certification obtenue ✅",
  "BP Responsable d’entreprise hippique : 1 candidat présenté / 1 certification obtenue ✅",
  "BP Éducateur canin : 1 candidat présenté / 1 certification obtenue ✅",
  "CAPa Palefrenier soigneur : 1 candidat présenté / 1 certification obtenue ✅",
  "DEAS : 1 candidat présenté / 1 certification obtenue ✅",
  "DEAES : 1 candidat présenté / 1 certification obtenue ✅",
  "BTS Maintenance des véhicules : 1 candidat présenté / 1 certification obtenue ✅",
  "TP Gestionnaire de paie : 1 candidat présenté / 1 certification obtenue ✅",
];

let allCertifications = () => {
  return certifications;
};

export const certificationVaeService = {
  allCertifications,
};

export default certificationVaeService;
